module.exports = __webpack_public_path__ + "media/openWin.e0173bd8.mp4";